import { ComponentProps } from "react";
import { OpaqueColorValue } from "react-native";
import { GetThemeValueForKey, styled, Text, View } from "tamagui";

const TagContainer = styled(View, {
  name: "TagContainer",
  width: "auto",
  alignSelf: "center",
  variants: {
    size: {
      lg: {
        paddingHorizontal: "$3",
        paddingVertical: "$0.5",
      },
    },
    rounded: {
      xl: {
        borderRadius: "$8",
      },
      lg: {
        borderRadius: "$4",
      },
      md: {
        borderRadius: "$1",
      },
    },
    variant: {
      light: {
        backgroundColor: "$lightpink-500",
      },
      primary: {
        backgroundColor: "$pinkmain-500",
      },
    },
  } as const,
  defaultVariants: {
    size: "lg",
    rounded: "lg",
    variant: "light",
  },
});

const TagText = styled(Text, {
  name: "TagText",
  fontFamily: "$subtitle",
  width: "auto",
  textAlign: "center",
  variants: {
    font: {
      lg: {
        fontWeight: "$4",
        fontSize: "$3",
        lineHeight: "$3",
      },
    },
    variant: {
      light: {
        color: "$gray-primary-900",
      },
      primary: {
        color: "#FFF",
      },
    },
  } as const,
  defaultVariants: {
    variant: "light",
    font: "lg",
  },
});

export type TagContainerProps = ComponentProps<typeof TagContainer> & {
  color?: "unset" | OpaqueColorValue | GetThemeValueForKey<"color"> | undefined;
  size?: "lg" | "md";
  variant?: "light" | "primary";
  rounded?: "xl" | "lg" | "md";
};

export const Tag: React.FC<TagContainerProps> = ({
  children,
  color,
  size = "lg",
  variant = "light",
  ...rest
}) => {
  return (
    <TagContainer size={size} variant={variant} {...rest}>
      <TagText color={color} variant={variant} font={size}>
        {children}
      </TagText>
    </TagContainer>
  );
};
